import {
  LayoutContent as baseLayoutText,
  getLocalizedContent,
} from "@onzeit/shared";
import { useParams } from "@remix-run/react";
import { NewsletterForm } from "~/components";

export default function Index() {
  const { locale } = useParams();
  const layoutText = getLocalizedContent(locale!, baseLayoutText);
  return (
    <div className="flex justify-center">
      <div className="max-w-xl text-center">
        <h1 className="text-4xl"> Herzlich Willkommen bei Onzeit!</h1>
        <p className="my-4 text-2xl">
          Wir freuen uns sehr, dass du den Weg zu uns gefunden hast.
        </p>
        <p className="text-lg">
          Unser Produkt, das darauf abzielt, deinen Arbeitstag entspannter und
          effizienter zu gestalten, wird im 1. Quartal 2024 starten.
          <p className="my-6 font-bold">
            Möchtest du genau wissen, wann es losgeht?
          </p>
          Hinterlasse einfach deine E-Mail-Adresse, wir informieren dich
          rechtzeitig und liefern dir Neuigkeiten direkt in dein Postfach.
          <p className="my-6 ">
            🤫Wenn du deine E-Mail-Adresse einträgst, erhälst du zu unserem
            Start 10% Rabatt von uns.
          </p>
          Wir freuen uns auf dich und den Start von Onzeit im 1. Quartal 2024!
          Dein Onzeit-Team
        </p>
        <div className="flex justify-center">
          <div className="max-w-md">
            <NewsletterForm
              text={layoutText}
              Form="form"
              errors={[]}
              success={false}
              locale={locale!}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
